(function () {
  'use strict';

  function init(form) {
    const brandSelect = form.querySelector('[data-vf-brand]');
    const modelSelect = form.querySelector('[data-vf-model]');
    const btn        = form.querySelector('[data-vf-btn]');

    if (!brandSelect || !modelSelect || !btn) return;

    brandSelect.addEventListener('change', function () {
      const brand = this.value;

      modelSelect.innerHTML = '';
      modelSelect.disabled  = true;
      btn.disabled          = true;
      btn.setAttribute('aria-disabled', 'true');

      if (!brand) {
        modelSelect.appendChild(buildOption('', 'Elige tu modelo de carro'));
        return;
      }

      modelSelect.appendChild(buildOption('', 'Selecciona el modelo'));

      const models = (window.__vfData || {})[brand] || [];
      models.forEach(function (model) {
        modelSelect.appendChild(buildOption(model, model));
      });

      modelSelect.disabled = false;
    });

    modelSelect.addEventListener('change', function () {
      const ready = brandSelect.value !== '' && this.value !== '';
      btn.disabled = !ready;
      btn.setAttribute('aria-disabled', String(!ready));
    });

    btn.addEventListener('click', function () {
      const brand = brandSelect.value;

      if (!brand) return;

      window.location.href = '/collections/modelos-de-apoyabrazos';
    });
  }

  function buildOption(value, label) {
    const opt   = document.createElement('option');
    opt.value   = value;
    opt.textContent = label;
    return opt;
  }

  function setup() {
    document.querySelectorAll('[data-vf-brand]').forEach(function (brandSelect) {
      const form = brandSelect.closest('[id^="vf-form-"]');
      if (form && !form.dataset.vfReady) {
        form.dataset.vfReady = '1';
        init(form);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const form = e.target.querySelector('[id^="vf-form-"]');
    if (form) {
      delete form.dataset.vfReady;
      init(form);
    }
  });
})();
